import { api } from "./api";

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

export async function updatePhone(whatsAppNumber, pacienteId) {
  if (!whatsAppNumber || !pacienteId) {
    throw new Error('Número de telefone e id do paciente são obrigatórios');
  }

  const response = await api(`${ENDPOINT}/client/update_user_phone`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      whatsapp: whatsAppNumber,
      id_cliente_deovita: pacienteId,
    }),
  });

  return await response.json();
}
